import {
  Component,
  HostListener,
  OnDestroy,
  ViewChild,
  inject,
} from '@angular/core';
import { SiaParamsAndPatternsService } from '@sia/shared';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';

import { SiaTranslatePipe } from '@sia/shared';
import {
  DxiColumnModule,
  DxoColumnChooserModule,
  DxoEditingModule,
  DxoFilterRowModule,
  DxoGroupPanelModule,
  DxoGroupingModule,
  DxoHeaderFilterModule,
  DxoLoadPanelModule,
  DxoLookupModule,
  DxoRemoteOperationsModule,
  DxoScrollingModule,
  DxoSearchPanelModule,
  DxoSelectionModule,
  DxoSortingModule,
} from 'devextreme-angular/ui/nested';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-cols-part-three',
  templateUrl: './sia-grid-config-cols-part-three.component.html',
  styleUrls: ['./sia-grid-config-cols-part-three.component.scss'],
  providers: [
    {
      provide: SiaGridConfigTab,
      useExisting: SiaGridConfigColsPartThreeComponent,
    },
  ],
  standalone: true,
  imports: [
    DxDataGridModule,
    DxiColumnModule,
    DxoLookupModule,
    DxoEditingModule,
    DxoSelectionModule,
    DxoRemoteOperationsModule,
    DxoSortingModule,
    DxoColumnChooserModule,
    DxoLoadPanelModule,
    DxoHeaderFilterModule,
    DxoFilterRowModule,
    DxoSearchPanelModule,
    DxoGroupPanelModule,
    DxoGroupingModule,
    DxoScrollingModule,
    SiaTranslatePipe,
  ],
})
export class SiaGridConfigColsPartThreeComponent
  extends SiaGridConfigTab
  implements OnDestroy
{
  private paramsAndPatternService = inject(SiaParamsAndPatternsService);

  @ViewChild(DxDataGridComponent, { static: false })
  childDataGrid: DxDataGridComponent | undefined;

  gridConfSummaryTypes: any[] = [
    { id: '', name: 'Nessuno' },
    { id: 'sum', name: 'Somma' },
    { id: 'count', name: 'Count' },
    { id: 'min', name: 'Minimo' },
    { id: 'max', name: 'Massimo' },
    { id: 'avg', name: 'Media' },
  ];

  gridConfSortOrderTypes: any[] = [
    { id: '', name: 'Nessuno' },
    { id: 'asc', name: 'Asc' },
    { id: 'desc', name: 'Desc' },
  ];

  @HostListener('window:unload')
  ngOnDestroy() {
    this.destroyDxComponent(this.childDataGrid, 'gridConfig3');
    this.gridConfSummaryTypes = [];
    this.gridConfSortOrderTypes = [];
    super.ngOnDestroy();
  }

  ngOnInit() {
    this.gridConfFiltersTypes = this.paramsAndPatternService.operators;
  }
}
